import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './helper/util/AuthContext';
import ProtectedRoute from './helper/util/ProtectedRoutes';

import Layout from './helper/layout';
import Register from './components/Registration';
import Login from './components/Login';
import LeadManagement from "./components/LeadManagement";
import ReviewPage from './components/Review';
import Profile from './components/Profile';
import MiniMarketing from './components/MiniMarketing';

import './App.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* Routes without header */}
          <Route path="/login" element={<Login />} />
          <Route path="/review/:token" element={<ReviewPage />} />
          <Route path="/marketing" element={<MiniMarketing />} />

          {/* Routes with header (MainLayout renders Header + Outlet) */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/manage-lead" replace />} />
            <Route element={<ProtectedRoute routePath="manage-lead" />}>
              <Route path="manage-lead" element={<LeadManagement />} />
            </Route>
            <Route element={<ProtectedRoute routePath="register" />}>
              <Route path="register" element={<Register />} />
            </Route>
            <Route element={<ProtectedRoute routePath="profile" />}>
              <Route path="profile" element={<Profile />} />
            </Route>
          </Route>
          <Route path="*" element={<div style={{ padding: 24 }}>404 - Not Found</div>} />
          

          {/* <Route element={<ProtectedRoute routePath="/lead-status" />}>
            <Route path="/lead-status" element={<Dashboard />} />
          </Route> */}

          
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

